'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _FileOutlined = _interopRequireDefault(require('./lib/icons/FileOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _FileOutlined;
exports.default = _default;
module.exports = _default;